import { Component ,ViewChild} from '@angular/core';
import {IonicPage, MenuController, NavController, NavParams, Slides} from 'ionic-angular';

import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { FileOpener } from '@ionic-native/file-opener';

import { UserProvider } from '../../providers/user';
import { LoadingProvider } from '../../providers/loading';


import { InAppBrowser } from '@ionic-native/in-app-browser';

import * as moment from "moment";

/**
 * Generated class for the NewsReadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-news-read',
  templateUrl: 'news-read.html',
})

export class NewsReadPage {
    @ViewChild('slider') slider: Slides;

  pdf_path: string = 'https://app.fw-wesling.de/uploads/news/';
  news: any;

  constructor(public navCtrl: NavController, private iab: InAppBrowser, public navParams: NavParams, public userProvider: UserProvider, private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider) {
    this.news = this.navParams.get('news');
  }


  formatNewsDate(date: any) {
      return moment(date).format('dddd, D. MMMM YYYY');
  }
    ngAfterViewInit() {
        setTimeout(() => {
            if(this.slider) {
                this.slider.autoHeight = true;
                this.slider.update();
            }
        }, 500);


    }
    ngOnInit() {
    }
  ionViewDidLoad() {
      console.log('ionViewDidLoad NewsReadPage');
  }

  openPDF(document_name,news_id, fileUrl){
      const fileTransfer: FileTransferObject = this.transfer.create();
      console.log(this.pdf_path + fileUrl);
      console.log(this.file.dataDirectory + 'news-'+news_id+'.pdf');

      this.loadingProvider.show();
      fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + 'news-'+news_id+'.pdf').then((entry) => {
          this.loadingProvider.hide();
          this.fileOpener.open(entry.toURL(), 'application/pdf')
              .then(() => console.log('File is opened'))
              .catch(e => console.log('Error opening file', e));
      }, (error) => {
          // handle error
      });
  }


  openWebsite(link: string) {
      this.iab.create(link, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/pages/news-read/news-read.ts